var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mb-0 shadow"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"animate__animated animate__fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('modulo-comentario',{attrs:{"module":"Paf","id":_vm.acompanhamento.id}})],1)])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }